import {
  Link,
  useLocation,
  useNavigation,
  useNavigate,
  useSearchParams,
} from '@remix-run/react';
import React, {useState} from 'react';
import {
  ProductOption,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';
import Tippy from '@tippyjs/react/headless';
import clsx from 'clsx';
import {forwardRef, useEffect} from 'react';

import Tooltip from '~/components/elements/Tooltip';
import {SanityCustomProductOption} from '~/lib/sanity';

import {getMaterialName} from '~/lib/utils';

export default function ProductOptions({
  options,
  selectedVariant,
  customProductOptions,
  allVariants,
  lang,
  availableForSale,
}: {
  options: ProductOption[];
  selectedVariant: ProductVariant;
  customProductOptions?: SanityCustomProductOption[];
  allVariants: Array;
  lang: String;
  availableForSale: Boolean;
}) {
  const {pathname, search} = useLocation();
  const [currentSearchParams] = useSearchParams();
  const navigation = useNavigation();
  const navi = useNavigate();

  const [isSoldOutComplete, setIsSoldOutComplete] = useState(true);

  const paramsWithDefaults = (() => {
    const defaultParams = new URLSearchParams(currentSearchParams);

    if (!selectedVariant) {
      return defaultParams;
    }

    for (const {name, value} of selectedVariant.selectedOptions) {
      if (!currentSearchParams.has(name)) {
        defaultParams.set(name, value);
      }
    }

    return defaultParams;
  })();

  // Update the in-flight request data from the 'navigation' (if available)
  // to create an optimistic UI that selects a link before the request is completed
  const searchParams = navigation.location
    ? new URLSearchParams(navigation.location.search)
    : paramsWithDefaults;

  //

  useEffect(() => {
    options.map((option) => {
      {
        option.values.map((value, index) => {
          //
          if (option.name === 'Größe' || option.name === 'Size') {
            let checkTemp = allVariants.nodes[index].availableForSale;

            if (checkTemp === true) {
              setIsSoldOutComplete(false);
            }
          }

          //
        });
      }
    });
  }, [setIsSoldOutComplete]);

  //

  return (
    <div className="grid gap-4">
      {isSoldOutComplete === true ? (
        <>
          <div className="mb-3 text-lg font-bold uppercase text-red">
            Sold out
          </div>
        </>
      ) : (
        <></>
      )}

      {/* Each option will show a label and option value <Links> */}
      {options.map((option) => {
        if (!option.values.length) {
          return;
        }
        // get the currently selected option value
        const currentOptionVal = searchParams.get(option.name);

        // Check if current product has a valid custom option type.
        // If so, render a custom option component.
        const customProductOption = customProductOptions?.find(
          (customOption) => customOption.title === option.name,
        );

        let tempOptions = option.values[0].split(',');
        let newOptions = [];

        tempOptions?.map((value, index) => {
          let temp = '';

          let finalName = getMaterialName(value, lang);

          /* *** */

          let checkSlash = value.includes(' / ');

          if (checkSlash === true) {
            finalName = '';
            let slashValues = value.split(' / ');

            slashValues?.map((value, index) => {
              let slashName = getMaterialName(value, lang);
              finalName += slashName;
              if (index < slashValues.length - 1) {
                finalName += ', ';
              }
            });
          } else {
            //

            let temp = '';

            let finalName = getMaterialName(value, lang);

            /* *** */

            let checkSlash = value.includes(' / ');

            if (checkSlash === true) {
              finalName = '';
              let slashValues = value.split(' / ');

              slashValues?.map((value, index) => {
                let slashName = getMaterialName(value, lang);
                finalName += slashName;
                if (index < slashValues.length - 1) {
                  finalName += ', ';
                }
              });
            } else {
              //
            }
          }

          /* *** */

          if (index !== 0) {
            temp = ' ' + finalName;
          } else {
            temp = '' + finalName;
          }

          newOptions.push(temp);
        });

        newOptions = newOptions.toString();

        return (
          <div key={option.name}>
            <legend className="mb-2 text-xs text-darkGray">
              {option.name === 'Größe' && lang === 'EN' ? (
                <>Size</>
              ) : (
                <>
                  {option.name === 'Color' && lang === 'DE' ? (
                    <>Farbe</>
                  ) : (
                    <>{option.name}</>
                  )}
                </>
              )}
            </legend>

            <div className="flex flex-wrap items-center gap-1">
              {option.values.map((value, index) => {
                const linkParams = new URLSearchParams(searchParams);
                const isSelected = currentOptionVal === value;

                linkParams.set(option.name, value);

                const id = `option-${option.name}-${value}`;
                const isSizeAvailable =
                  allVariants.nodes[index].availableForSale;

                switch (customProductOption?._type) {
                  case 'customProductOption.color': {
                    const foundCustomOptionValue =
                      customProductOption.colors.find(
                        (color) => color.title === value,
                      );

                    return (
                      <Tippy
                        placement="top"
                        render={() => {
                          if (!foundCustomOptionValue) {
                            return null;
                          }
                          return (
                            <Tooltip label={foundCustomOptionValue.title} />
                          );
                        }}
                        key={id}
                      >
                        <ColorButton
                          to={`${pathname}?${linkParams.toString()}`}
                          isSelected={isSelected}
                          hex={foundCustomOptionValue?.hex || '#fff'}
                        />
                      </Tippy>
                    );
                  }
                  case 'customProductOption.size': {
                    const foundCustomOptionValue =
                      customProductOption.sizes.find(
                        (size) => size.title === value,
                      );

                    return (
                      <Tippy
                        placement="top"
                        render={() => {
                          if (!foundCustomOptionValue) {
                            return null;
                          }
                          return (
                            <Tooltip
                              label={`${foundCustomOptionValue.width}cm x ${foundCustomOptionValue.height}cm`}
                            />
                          );
                        }}
                        key={id}
                      >
                        <OptionButton
                          to={`${pathname}?${linkParams.toString()}`}
                          isSelected={isSelected}
                        >
                          {value}
                        </OptionButton>
                      </Tippy>
                    );
                  }
                  default:
                    return (
                      <>
                        {option.name === 'Größe' || option.name === 'Size' ? (
                          <>
                            {isSizeAvailable === true ? (
                              <>
                                <OptionButton
                                  to={`${pathname}?${linkParams.toString()}`}
                                  isSelected={isSelected}
                                  key={id}
                                >
                                  {option.name === 'Größe' ||
                                  option.name === 'Size' ? (
                                    <span
                                      className={` ${
                                        isSizeAvailable === true
                                          ? ' isA '
                                          : ' isNotA line-through '
                                      }`}
                                    >
                                      {value}
                                    </span>
                                  ) : (
                                    <span>{newOptions}</span>
                                  )}
                                </OptionButton>
                              </>
                            ) : (
                              <>
                                <div className="cursor-default rounded-[6px] border border-lightGray px-3 py-2 text-sm leading-none text-darkGray">
                                  {option.name === 'Größe' ||
                                  option.name === 'Size' ? (
                                    <span
                                      className={` ${
                                        isSizeAvailable === true
                                          ? ' isA '
                                          : ' isNotA line-through '
                                      }`}
                                    >
                                      {value}
                                    </span>
                                  ) : (
                                    <span>{newOptions}</span>
                                  )}
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <OptionButton
                              to={`${pathname}?${linkParams.toString()}`}
                              isSelected={isSelected}
                              key={id}
                            >
                              {option.name === 'Größe' ||
                              option.name === 'Size' ? (
                                <span
                                  className={` ${
                                    isSizeAvailable === true
                                      ? ' isA '
                                      : ' isNotA line-through '
                                  }`}
                                >
                                  {value}
                                </span>
                              ) : (
                                <>
                                  {option.name === 'Color' ||
                                  option.name === 'Farbe' ? (
                                    <span>{value}</span>
                                  ) : (
                                    <span>{newOptions}</span>
                                  )}
                                </>
                              )}
                            </OptionButton>
                          </>
                        )}
                      </>
                    );
                }
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

const OptionButton = forwardRef<
  HTMLAnchorElement,
  {to: string; isSelected: boolean; children: React.ReactNode}
>((props, ref) => {
  const {to, isSelected, children} = props;

  return (
    <Link
      ref={ref}
      to={to}
      preventScrollReset
      replace
      className={clsx([
        'cursor-pointer rounded-[6px] border px-3 py-2 text-sm leading-none',
        isSelected
          ? 'border-black text-black'
          : 'border-lightGray text-darkGray',
      ])}
    >
      {children}
    </Link>
  );
});

const ColorButton = forwardRef<
  HTMLAnchorElement,
  {to: string; hex: string; isSelected: boolean}
>((props, ref) => {
  const {to, hex, isSelected} = props;

  return (
    <Link
      ref={ref}
      to={to}
      preventScrollReset
      replace
      className={clsx([
        'flex h-8 w-8 items-center justify-center rounded-full border',
        isSelected
          ? 'border-offBlack'
          : 'cursor-pointer border-transparent hover:border-black hover:border-opacity-30',
      ])}
    >
      <div
        className="rounded-full"
        style={{
          background: hex,
          height: 'calc(100% - 4px)',
          width: 'calc(100% - 4px)',
        }}
      ></div>
    </Link>
  );
});
